import React from 'react';

const createTextElement = (text: string, key?: string | number) => {
	return <span key={key}>{text.trim()}</span>;
};

const createLineBreakElement = (key?: string | number) => {
	return <br key={key} />;
};

// TODO: test / cleanup
export const newlineStringToElements = (str: string, key?: string | number) => {
	if (str === '\n') return [createLineBreakElement(key)];

	const pieces = str.split('\n');
	if (pieces.length === 1) return [createTextElement(pieces[0], key)];

	let firstItemWasNewLine = false;
	return pieces.map((item, index) => {
		if (index === 0) {
			if (item === '') {
				firstItemWasNewLine = true;
				return createLineBreakElement(index);
			}
			return createTextElement(item, index);
		}
		return firstItemWasNewLine && index === 1
			? createTextElement(item, `span-${index}`)
			: [
					createLineBreakElement(index),
					createTextElement(item, `span-${index}`),
			  ];
	});
};
